import PixPaymentModal from "../../modal/PixPaymentModal";

const PagbrasilPaymentFormView = ({
  t,
  documentNumber,
  loading,
  error,
  documentError,
  pixResponse,
  isEmbeddedCheckout,
  itemDetails,
  checkoutPageConfDto,
  latestSession,
  onDocumentChange,
}) => {
  return (
    <div className="qr-container">
      {pixResponse != null && !isEmbeddedCheckout ? (
        <>
          <PixPaymentModal
            response={pixResponse.data}
            itemDetails={itemDetails}
            checkoutPageConfDto={checkoutPageConfDto}
            latestSession={latestSession}
            gateway="pagbrasil"
          />

          {loading && (
            <div className="loader-overlay">
              <div className="spinner-large" />
            </div>
          )}
        </>
      ) : (
        <div className="input-section">
          <label className="input-label">
            {t("paymentForms.pix.document")}
          </label>

          <div className="input-wrapper">
            <input
              type="text"
              className="document-input"
              placeholder={t("paymentForms.pix.documentPlaceholder")}
              value={documentNumber}
              onChange={onDocumentChange}
              disabled={loading}
              maxLength={14}
            />
          </div>

          <p className="input-hint">
            {t("paymentForms.pix.subscriptionNotice")}
          </p>

          {documentError && (
            <div className="error-message">{documentError}</div>
          )}

          {error && (
            <div className="error-message">{error}</div>
          )}

          {loading && (
            <div className="loader-overlay">
              <div className="spinner-large" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PagbrasilPaymentFormView;
